import CssBaseline from "@material-ui/core/CssBaseline"
import { ThemeProvider } from "@material-ui/styles"
import React from "react"
import ReactDOM from "react-dom"
import { renderRoutes } from "react-router-config"
import { BrowserRouter } from "react-router-dom"
import theme from "./theme"
import routes from "./routes"

const app = (
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
            {renderRoutes(routes)}
        </BrowserRouter>
    </ThemeProvider>
)

ReactDOM.render(app, document.getElementById("root"))


